import React, { Component } from 'react'
import News_item from './News_item.js'
import Pagination from './Pagination.js';
import { useState } from 'react'

export class News extends Component {
    articles = [[
        {
            "source": {
                "id": null,
                "name": "The Guardian"
            },
            "author": "Samuel Gibbs Consumer technology editor",
            "title": "Beats Studio Buds+ review: Apple’s latest for Android and iPhone",
            "description": "Compact Bluetooth earbuds get better sound, noise-cancelling and battery life – and a funky clear caseThe latest Beats earbuds from Apple improve the noise-cancelling and sound of their predecessors – and make them easier to use across almost all phones while…",
            "url": "https://www.theguardian.com/technology/2023/may/22/beats-studio-buds-review-apple-android-iphone-bluetooth-earbuds",
            "urlToImage": "https://i.guim.co.uk/img/media/d2fed37d7919f55ce8b170de767768582c34dce8/381_377_4646_2787/master/4646.jpg?width=1200&height=630&quality=85&auto=format&fit=crop&overlay-align=bottom%2Cleft&overlay-width=100p&overlay-base64=L2ltZy9zdGF0aWMvb3ZlcmxheXMvdGctcmV2aWV3LTQucG5n&enable=upscale&s=df2aa3600895441f1bebe7a0b2ce6623",
            "publishedAt": "2023-05-22T06:00:48Z",
            "content": "The latest Beats earbuds from Apple improve the noise-cancelling and sound of their predecessors and make them easier to use across almost all phones while adding a fresh transparent option.\r\nThe Stu… [+6279 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "The Guardian"
            },
            "author": "John Harris",
            "title": "‘There was all sorts of toxic behaviour’: Timnit Gebru on her sacking by Google, AI’s dangers and big tech’s biases",
            "description": "The Ethiopian-born computer scientist lost her job after pointing out the inequalities built into AI. But after decades working with technology companies, she knows all too much about discrimination‘It feels like a gold rush,” says Timnit Gebru. “In fact, it …",
            "url": "https://www.theguardian.com/lifeandstyle/2023/may/22/there-was-all-sorts-of-toxic-behaviour-timnit-gebru-on-her-sacking-by-google-ais-dangers-and-big-techs-biases",
            "urlToImage": "https://i.guim.co.uk/img/media/8315430000e6e4e64af6679eb5fcd095c521b17a/246_635_4709_2825/master/4709.jpg?width=1200&height=630&quality=85&auto=format&fit=crop&overlay-align=bottom%2Cleft&overlay-width=100p&overlay-base64=L2ltZy9zdGF0aWMvb3ZlcmxheXMvdGctZGVmYXVsdC5wbmc&enable=upscale&s=301a4055c4f86892a9045114f1104f57",
            "publishedAt": "2023-05-22T05:00:47Z",
            "content": "It feels like a gold rush, says Timnit Gebru. In fact, it is a gold rush. And a lot of the people who are making money are not the people actually in the midst of it. But its humans who decide whethe… [+21146 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "MacRumors"
            },
            "author": "Joe Rossignol",
            "title": "Apple Likely Filed for 'xrProOS' Trademark Last Week via Shell Company",
            "description": "Just a few weeks ahead of WWDC, it appears that Apple continues to secretly apply for trademarks related to its rumored AR/VR headset.\n\n\n\nApple headset concept by designer Marcus Kane\n\nDelaware-based shell company \"Deep Dive LLC\" submitted a trademark applica…",
            "url": "https://www.macrumors.com/2023/05/21/xrproos-trademark-application/",
            "urlToImage": "https://images.macrumors.com/t/0AEwkV1vA2kxu5iASHNCMdS9VXM=/2674x/article-new/2023/04/apple-headset-underside-render-by-marcus-kane.jpg",
            "publishedAt": "2023-05-22T01:24:57Z",
            "content": "Just a few weeks ahead of WWDC, it appears that Apple continues to secretly apply for trademarks related to its rumored AR/VR headset.\r\nDelaware-based shell company \"Deep Dive LLC\" submitted a tradem… [+2120 chars]"
        },
        {
            "source": {
                "id": "business-insider",
                "name": "Business Insider"
            },
            "author": "Thomas Maxwell",
            "title": "Apple's tax on AI inventions has begun. It will cost OpenAI and others hundreds of millions of dollars a year.",
            "description": "OpenAI's new ChatGPT app for iOS has rocketed up the App Store charts. And the company is giving Apple a 30% cut of new ChatGPT Plus subscriptions.",
            "url": "https://www.businessinsider.com/apple-chatgpt-ai-app-store-tax-openai-ios-2023-5",
            "urlToImage": "https://i.insider.com/641322545f4f54001919e137?width=1200&format=jpeg",
            "publishedAt": "2023-05-22T09:00:07Z",
            "content": "Apple CEO Tim CookJerod Harris/Getty Images Entertainment\r\n<ul>\n<li>On Thursday, OpenAI launched an iPhone app for the wildly popular ChatGPT.</li>\n<li>The app quickly rocketed up to the top of the i… [+3333 chars]"
        }
    ]]
    constructor(props) {
        super(props);
        console.log("constructor initiated");
        this.state = {
            allArticles: this.articles,
            loading: false,
            currentPage: 1,
            article_idx: 0,
            hasMounted: false,
            loading: true
        };
    }

    async componentDidMount() {
        console.log("inside compMount");
        this.setState({ loading: true });
        let new_page = this.state.currentPage;
        let url = `https://newsapi.org/v2/everything?q=news&apiKey=fe2565c7f9634556b21cda174281e54a&page=${new_page}&pagesize=10`
        let response = await fetch(url);
        if (!response.ok) {
            this.setState({
                loading: false
            })
            return;
        }
        let data = await response.json();
        let filtered_articles = data.articles.filter(article => article.urlToImage);
        let new_articles = [...filtered_articles];
        while (new_articles.length < 10) {
            new_page++;
            url = `https://newsapi.org/v2/everything?q=news&apiKey=fe2565c7f9634556b21cda174281e54a&page=${new_page}&pagesize=10`
            response = await fetch(url);
            if (!response.ok) break;
            data = await response.json();
            if (data.articles.length === 0) break;
            filtered_articles = data.articles.filter(article => article.urlToImage);
            new_articles = [...new_articles, ...filtered_articles];
        }
        console.log(new_articles.length);
        if (this.state.hasMounted) return;
        this.setState({
            allArticles: [...this.state.allArticles, new_articles],
            totalArticles: data.totalResults,
            article_idx: this.state.article_idx + 1,
            hasMounted: true,
            loading: false
        });

    }

    loading_screen = () => {
        this.setState({ loading: true }, () => {window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })}
        )
    }

    handleHome = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        this.setState({
            article_idx: 1,
            loading: false
        })
    };

    handlePrev = () => {
        console.log("prev: get to top")

        this.setState({
            article_idx: this.state.article_idx - 1
        }, () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        });
    };

    handleNext = async () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        this.setState({ loading: true });
        if (this.state.article_idx + 1 < this.state.allArticles.length) {
            this.setState({
                article_idx: this.state.article_idx + 1,
                loading: false
            })
        }
        else {
            let new_page = this.state.currentPage + 1;
            let url = `https://newsapi.org/v2/everything?q=news&apiKey=fe2565c7f9634556b21cda174281e54a&page=${new_page}&pagesize=10`
            let response = await fetch(url);
            if (!response.ok) {
                this.setState({ loading: false });
                return;
            }
            let data = await response.json();
            let filtered_articles = data.articles.filter(article => article.urlToImage);
            let new_articles = [...filtered_articles];
            console.log(new_articles);
            while (new_articles.length < 10) {
                new_page++;
                url = `https://newsapi.org/v2/everything?q=news&apiKey=fe2565c7f9634556b21cda174281e54a&page=${new_page}&pagesize=10`
                response = await fetch(url);
                if (!response.ok) break;
                data = await response.json();
                if (data.articles.length === 0) break;
                filtered_articles = data.articles.filter(article => article.urlToImage);
                new_articles = [...new_articles, ...filtered_articles];
            }
            this.setState({
                allArticles: [...this.state.allArticles, new_articles],
                currentPage: new_page,
                article_idx: this.state.article_idx + 1,
                loading: false
            });
        }
    };


    render() {
        const { allArticles, article_idx, loading } = this.state;

        if (loading) {
            return (
                <>
                    <div className='container d-flex justify-content-center align-items-center' style={{ minHeight: "100vh" }}>
                        <div className='dots'>
                            <div className='dot dance' style={{ animationDelay: '0ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '910ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '100ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '810ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '200ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '710ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '300ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '610ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '500ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '410ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '400ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '510ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '600ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '310ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '700ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '210ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '800ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '110ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '900ms' }}></div>
                            <div className='dot dance' style={{ animationDelay: '10ms' }}></div>

                        </div>
                    </div>
                    {/* <div className='justify-content-center'>
                    Loading......
                </div> */}
                </>

            )
        }

        // Get the news items for the current page
        const currentNewsItems = allArticles[article_idx];

        return (
            <div className='container'>
                <h4 className={`${this.props.mode==='sun'?'text-dark':'text-light'}`}>News Headlines</h4>
                <div className='custom_1'>
                    {currentNewsItems.map((news) => {
                        return (
                            <div key={news.url}>
                                <News_item data={news} mode={this.props.mode} />
                            </div>
                        )
                    })}
                </div>
                {/* Pagination component */}
                <hr />
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <button disabled={article_idx <= 1} type="button" className={`btn btn-${this.props.mode==='sun'?'primary':'danger'} btn-sm`} onClick={this.handlePrev}> &larr; Previous </button>
                    <button type="button" className={`btn btn-${this.props.mode==='sun'?'primary':'danger'} btn-sm`} onClick={this.handleNext}> Next &rarr; </button>
                </div>
            </div>
        )
    }
}

export default News
